import { store } from 'redux/store'
import { useCookies } from 'react-cookie'

import queryString from 'query-string'

import { SET_COLLECTION_V2_STATE } from 'redux/collectionV2/actions/types'

import { COLLECTION_COOKIE_KEY } from 'redux/collectionV2/helpers/cachedValues'

export type CollectionQueryParams = {
  cardName?: string
  syntaxQuery?: string

  collectionOrderBy?: string
  orderDirection?: 'ascending' | 'descending'
  priceSource?: string

  game?: 1 | 2 | 3
  tags?: string // CSV of tagIds

  condition?: string // CSV of conditionIds
  collectionLanguage?: string // CSV of languageIds

  page?: number | string
  pageSize?: number
}

export const useBuildCollectionUrl = (specificUserId?: string | number) => {
  const [{ tbId: userId, [COLLECTION_COOKIE_KEY]: cachedState = {} }] = useCookies(['tbId', COLLECTION_COOKIE_KEY])

  // This loads someone elses collection without cached order by settings
  if (!!specificUserId && specificUserId !== userId) return `/collection/v2/${specificUserId}`

  if (!userId) return '/collection'

  if (typeof cachedState !== 'object' || !cachedState?.orderBy) return `/collection/v2/${userId}`

  const searchParams: Record<string, string> = {}

  if (cachedState?.orderBy) searchParams.collectionOrderBy = cachedState.orderBy
  if (cachedState?.orderDirection) searchParams.orderDirection = cachedState.orderDirection

  return `/collection/v2/${userId}?${queryString.stringify(searchParams)}`
}

export const setCollectionQueryParams = (params: Partial<CollectionQueryParams>, fullOverride = true) => {
  const { origin, pathname, search } = window.location

  const existingParams: any = queryString.parse(search)

  const newParams: CollectionQueryParams = {}

  if (fullOverride) {
    for (const key of Object.keys(existingParams)) {
      // @ts-ignore
      newParams[key] = existingParams[key]
    }
  }

  for (const key of Object.keys(params)) {
    // @ts-ignore
    newParams[key] = params[key]
  }

  if (!!params?.collectionOrderBy) {
    store.dispatch({
      type: SET_COLLECTION_V2_STATE,
      payload: { orderBy: params.collectionOrderBy },
    })
  }

  if (!!params?.orderDirection) {
    store.dispatch({
      type: SET_COLLECTION_V2_STATE,
      payload: { orderDirection: params.orderDirection },
    })
  }

  let forcePageParamToOne = false

  if (newParams.collectionOrderBy !== existingParams.collectionOrderBy) forcePageParamToOne = true
  if (newParams.orderDirection !== existingParams.orderDirection) forcePageParamToOne = true
  if (newParams.priceSource !== existingParams.priceSource) forcePageParamToOne = true

  if (forcePageParamToOne) newParams.page = 1

  // @ts-ignore
  window.location = origin + pathname + '?' + queryString.stringify(newParams)
}
